import React from 'react';
import { FieldArray } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import ContactFieldArray from './ContactFieldArray';
import {
  MAX_EMAIL_FIELDS,
  MAX_PHONE_FIELDS,
  EMAIL_TYPES,
  PHONE_TYPES,
  DEFAULT_EMAIL_ENTRY,
  DEFAULT_PHONE_ENTRY,
} from './constants';
import messages from './messages';

const ContactInformationMultiple = ({ intl, required, disabled }) => {
  // Generate type options with internationalization
  const emailTypeOptions = EMAIL_TYPES.map((type) => ({
    value: type.value,
    text: intl.formatMessage(messages[`emailType${type.text}`]),
  }));

  const phoneTypeOptions = PHONE_TYPES.map((type) => ({
    value: type.value,
    text: intl.formatMessage(messages[`phoneType${type.text}`]),
  }));

  return (
    <div className="form-content">
      <Typography variant="titleLarge">
        <FormattedMessage {...messages.title} />
      </Typography>
      <div style={{ height: '10px', visibility: 'hidden' }}>&nbsp;</div>
      <Row>
        <Col xs={12} md={6}>
          <FieldArray
            name="emails"
            component={ContactFieldArray}
            type="email"
            typeOptions={emailTypeOptions}
            maxFields={MAX_EMAIL_FIELDS}
            defaultEntry={DEFAULT_EMAIL_ENTRY}
            disabled={disabled}
            intl={intl}
          />
        </Col>
        <Col xs={12} md={6}>
          <FieldArray
            name="phones"
            component={ContactFieldArray}
            type="phone"
            typeOptions={phoneTypeOptions}
            maxFields={MAX_PHONE_FIELDS}
            defaultEntry={DEFAULT_PHONE_ENTRY}
            disabled={disabled}
            intl={intl}
          />
        </Col>
      </Row>
    </div>
  );
};

export default ContactInformationMultiple;
